import React from 'react';

const UploadFormularHeader = () => {
    return(
        <div className="container">
            <div className="row text-center">
                <div className="col-sm-12">
                    <h1 style={{paddingTop: '8rem'}}>Hochladen von Beiträgen in die Datenbank!</h1>
                    <hr />
                </div>
            </div>
        </div>
    );
}

export default UploadFormularHeader;